/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime (time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time, 10)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        // eslint-disable-next-line prefer-regex-literals
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time *= 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  // eslint-disable-next-line camelcase
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    return value.toString().padStart(2, '0')
  })
  // eslint-disable-next-line camelcase
  return time_str
}

/**
 * 图片压缩方法
 * @param {*} base64 图片base64
 * @param {*} w 压缩后图片宽度
 * @param {*} callback 回调，用于接收压缩结果
 */
export function compressImage (base64, w, callback) {
  const newImage = new Image()
  let quality = 0.9 // 压缩系数0-1之间
  newImage.src = base64
  newImage.setAttribute('crossOrigin', 'Anonymous')
  let imgWidth,
    imgHeight

  function onload () {
    imgWidth = this.width
    imgHeight = this.height
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    if (Math.max(imgWidth, imgHeight) > w) {
      if (imgWidth > imgHeight) {
        canvas.width = w
        canvas.height = (w * imgHeight) / imgWidth
      } else {
        canvas.height = w
        canvas.width = (w * imgWidth) / imgHeight
      }
    } else {
      canvas.width = imgWidth
      canvas.height = imgHeight
      quality = 0.9
    }
    ctx.clearRect(0, 0, canvas.width, canvas.height)
    ctx.drawImage(this, 0, 0, canvas.width, canvas.height)
    const result = canvas.toDataURL('image/jpeg', quality)
    // 如想确保图片压缩到自己想要的尺寸,如要求在50-150kb之间，请加以下语句，quality初始值根据情况自定
    // while (base64.length / 1024 > 150) {
    // quality -= 0.01;
    // base64 = canvas.toDataURL("image/jpeg", quality);
    // }
    // 防止最后一次压缩低于最低尺寸，只要quality递减合理，无需考虑
    // while (base64.length / 1024 < 50) {
    // quality += 0.001;
    // base64 = canvas.toDataURL("image/jpeg", quality);
    // }
    callback(result) // 必须通过回调函数返回，否则无法及时拿到该值
  }
  newImage.onload = onload
}

export function list2Tree (list, rootVal) {
  const arr = []
  list.map((item) => {
    if (item.parentId === rootVal) {
      const children = list2Tree(list, item.agencyId)
      if (children.length) {
        item.children = children.map(c => {
          return {
            ...c,
            isChildren: true
          }
        })
      }
      arr.push(item)
    }
  })
  return arr
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone (source) {
  let target
  if (typeof source === 'object' && source) {
    target = Array.isArray(source) ? [] : {}
    for (const key in source) {
      // eslint-disable-next-line no-prototype-builtins
      if (source.hasOwnProperty(key) && source) {
        if (typeof source[key] !== 'object') {
          target[key] = source[key]
        } else {
          target[key] = deepClone(source[key])
        }
      } else {
        target = ''
      }
    }
  } else {
    target = source
  }
  return target
}

// 16进制转中文
export function utf8to16 (str) {
  let out,
    i,
    len,
    c
  let char2,
    char3
  out = ''
  // eslint-disable-next-line prefer-const
  len = str.length
  i = 0
  while (i < len) {
    c = str.charCodeAt(i++)
    // eslint-disable-next-line default-case
    switch
    // eslint-disable-next-line no-bitwise
    (c >> 4) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
        out += str.charAt(i - 1)
        break
      case 12:
      case 13:
        char2 = str.charCodeAt(i++)
        // eslint-disable-next-line no-bitwise
        out += String.fromCharCode(((c & 0x1F) << 6) | (char2 & 0x3F))
        break
      case 14:
        char2 = str.charCodeAt(i++)
        char3 = str.charCodeAt(i++)
        // eslint-disable-next-line no-bitwise
        out += String.fromCharCode(((c & 0x0F) << 12) |
          // eslint-disable-next-line no-bitwise
          ((char2 & 0x3F) << 6) |
          // eslint-disable-next-line no-bitwise
          ((char3 & 0x3F) << 0))
        break
    }
  }

  return out
}

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal (path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 *
 * @param {array1} 递归数组
 * @param {array2} 递归后的菜单code数组
 * @returns array2
 */

export function recursionArray (array1, array2, key1, key2, name) {
  array1.forEach((item) => {
    array2.push(setKeyAndValue({}, item[key1], item.childList))
    const childList = item.childList || []
    childList.forEach((items) => {
      // eslint-disable-next-line no-use-before-define
      array2.push(setKeyAndValue({}, items[key1], items[key2], items[name]))
    })
  })
  return Object.assign({}, ...array2)
}
export function setKeyAndValue (obj = {}, key, value, name) {
  // if (key === 'CPGL' && name === '菜谱管理') {
  //   obj.CPUGL = value
  // } else {
  obj[key] = value
  // }
  return obj
}
